module.exports = __webpack_public_path__ + "media/images/athletes/1868-eb806d9072b538bf224aeea826438072.png";